import { PropsWithChildren } from 'react';

import { usePermissionsManager } from '@/hooks/usePermissionsManager';
import { usePermissionDenied } from '@/providers/PermissionDeniedProvider/PermissionDeniedContext.hooks';
import { NoPermissionsView } from '@/views/NoPermissionsView/NoPermissionsView';
import { StyledPageLoader } from '@/components/StyledSharedComponents/StyledLoader';

interface IPermittedRouteProps {
  isPermitted: boolean;
}

export const PermittedRoute = ({
  isPermitted,
  children,
}: PropsWithChildren<IPermittedRouteProps>) => {
  const { arePermissionsResolved } = usePermissionsManager();
  const { isPermissionDenied } = usePermissionDenied();

  if (!arePermissionsResolved) {
    return <StyledPageLoader />;
  }

  if (!isPermitted || isPermissionDenied) {
    return <NoPermissionsView />;
  }

  return <>{children}</>;
};
